import React from 'react';
import { StarIcon } from 'lucide-react';
const Testimonials = () => {
  const testimonials = [{
    name: 'Luis Morales',
    role: 'Líder comunitario, El Progreso',
    quote: 'Esta iniciativa es exactamente lo que nuestra región necesita. Un sistema que no solo distribuye agua, sino que también construye comunidad.',
    stars: 5
  }, {
    name: 'Andrea Paz',
    role: 'Directora de desarrollo local, Zacapa',
    quote: 'La combinación de tecnología y compromiso social que propone Guaterflow tiene el potencial de transformar el acceso al agua en nuestra región.',
    stars: 5
  }, {
    name: 'Roberto Méndez',
    role: 'Empresario local, Chiquimula',
    quote: 'Un modelo de negocio innovador que aborda una necesidad fundamental. La región está lista para dar este salto tecnológico en la distribución de agua.',
    stars: 5
  }];
  return <section id="testimonios" className="py-16 bg-blue-50" data-id="element-191">
      <div className="container mx-auto px-4" data-id="element-192">
        <div className="text-center mb-16" data-id="element-193">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-194">
            La región está lista para una solución como Guaterflow
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-195">
            Presentamos nuestra visión a líderes comunitarios y actores clave de
            la región. Esto es lo que dijeron sobre Guaterflow.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-196">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-md" data-id="element-197">
              <div className="flex mb-4" data-id="element-198">
                {[...Array(testimonial.stars)].map((_, i) => <StarIcon key={i} size={20} fill="#FFD700" color="#FFD700" data-id="element-199" />)}
              </div>
              <p className="text-gray-600 italic mb-6" data-id="element-200">"{testimonial.quote}"</p>
              <div data-id="element-201">
                <p className="font-semibold text-gray-800" data-id="element-202">
                  {testimonial.name}
                </p>
                <p className="text-gray-500 text-sm" data-id="element-203">{testimonial.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default Testimonials;